import { quillClassFromInstance } from '@calendly/rich-text-editor'
import { useRef, useCallback } from 'react'

import { useBooleanState } from 'hooks/useBooleanState'


export const useSimpleLinkPopup = () => {
  const reactQuillRef = useRef()
  const prefilledText = useRef('')
  const prefilledURL = useRef('')
  const selection = useRef({})
  const [isLinkPopupOpen, showLinkPopup, hideLinkPopup] = useBooleanState(false)


  const openLinkPopup = useCallback(async (editor, editorSelection, url) => {
    reactQuillRef.current = editor
    selection.current = editorSelection

    const plainText = editor.getText(editorSelection.index, editorSelection.length)
    prefilledText.current = plainText
    prefilledURL.current = url
    editor.focus()

    showLinkPopup()
  }, [showLinkPopup])

  const pasteLink = useCallback((text, url) => {
    const { index, length } = selection.current
    const quill = reactQuillRef.current
    const Quill = quillClassFromInstance(quill)
    const Delta = Quill.import('delta')

    const updates = new Delta()

    if (index) {
      updates.push({ retain: index })
    }

    if (length) {
      updates.push({ delete: length })
    }

    updates.push({ insert: text || url, attributes: { link: url } })

    quill.updateContents(updates, 'user')

    prefilledText.current = ''
    prefilledURL.current = ''

    hideLinkPopup()
  }, [hideLinkPopup])

  return {
    openLinkPopup,
    linkPopupProps: {
      isOpen: isLinkPopupOpen,
      prefilledText: prefilledText.current,
      prefilledURL: prefilledURL.current,
      onClose: hideLinkPopup,
      onConfirm: pasteLink
    }
  }
}
